module.exports = __webpack_public_path__ + "img/infodesk_mobile.c851b5aa.svg";